import { RDatePicker } from "./RDatePicker.jsx";
import { useState, useEffect } from 'react';
import moment from 'moment';

export const RDateRangePicker = props => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    useEffect(() => {
        if(props.selectedDates==""){
            setStartDate("");
            setEndDate("");
        }
    },[props.selectedDates]);

    useEffect(_=>{
        if(startDate!="" || endDate!="") 
        props.onChange(`${startDate && startDate != "" ? startDate : ""},${endDate && endDate != "" ? endDate : ""}`);
        else
        props.onChange("");
    },[startDate,endDate]);

    const checkValues = (s, e) => s && s != "" && e && e != ""
 
    return <div className={`d-flex${
            checkValues(startDate,endDate) && 
            !moment(moment(startDate).format("YYYY-MM-DD")).isSame(moment(endDate).format("YYYY-MM-DD"))
        ?" range-active":""}`}>
        <RDatePicker
            absolute={props.absolute}
            noSelectClose={true}
         limitYear={props.limitYear} yearRange={props.yearRange} limitDateAfter={endDate}
         selectedDate={startDate} dateRangeMode={props.dateRangeMode} rangeMode={true}
         onChange={e=>setStartDate(e === "" ? "" : moment(e).format("YYYY-MM-DD"))} />
        <span style={{minWidth:30,textAlign:'center'}}> to </span>
        <RDatePicker
            absolute={props.absolute}
            noSelectClose={true}
         limitYear={props.limitYear} yearRange={props.yearRange} limitDateBefore={startDate}
         selectedDate={endDate} dateRangeMode={props.dateRangeMode} rangeMode={true}
         onChange={e=>setEndDate(e === "" ? "" : moment(e).format("YYYY-MM-DD"))} />
    </div>
}